import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import "@/App.css";

import Loader from "@/components/Loader";
import MouseGlow from "@/components/MouseGlow";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Clients from "@/components/Clients";
import About from "@/components/About";
import Portfolio from "@/components/Portfolio";
import Featured from "@/components/Featured";
import Stats from "@/components/Stats";
import Course from "@/components/Course";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Admin from "@/components/Admin";

function App() {
  const [loading, setLoading] = useState(true);
  const lenisRef = useRef(null);
  const isAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");

  // Lenis smooth scroll (skip on admin page)
  useEffect(() => {
    if (isAdmin) return;
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      lerp: 0.1,
    });
    lenisRef.current = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, [isAdmin]);

  // Lock scroll while loading
  useEffect(() => {
    if (loading) {
      document.body.style.overflow = "hidden";
      lenisRef.current?.stop?.();
    } else {
      document.body.style.overflow = "";
      lenisRef.current?.start?.();
    }
  }, [loading]);

  if (isAdmin) return <Admin />;

  return (
    <div className="App grain min-h-screen bg-[#171717] text-white">
      <Loader onDone={() => setLoading(false)} />
      <MouseGlow />
      <Nav />
      <main data-testid="main-content">
        <Hero />
        <Clients />
        <About />
        <Portfolio />
        <Featured />
        <Stats />
        <Course />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
